module.exports = __webpack_public_path__ + "static/media/jewelry1.0b4227fd.jpg";